// web/src/screens/Stripe.tsx (/stripe) — "Payments": the client's money, managed with Stripe's embedded components
// (portal spec 16). Setup first (AcceptStripe), then banner + payouts + payments (refunds, disputes). Never shows our
// fee. What they pay us lives on Billing.
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ConnectComponentsProvider, ConnectNotificationBanner, ConnectPayments, ConnectPayouts } from '@stripe/react-connect-js';
import { api, IS_MOCK } from '../lib/api';
import { money } from '../lib/status';
import { STRIPE_PK, connectInstance } from '../lib/stripeConnect';
import { PageHeader } from '../components/PageHeader';
import { AcceptStripe } from '../components/AcceptStripe';

export function Stripe() {
  const status = useQuery({ queryKey: ['connectStatus'], queryFn: () => api.connectStatus() });
  const ready = !!status.data?.chargesEnabled;
  const summary = useQuery({ queryKey: ['paymentsSummary'], queryFn: () => api.paymentsSummary(), enabled: ready });
  const instance = useMemo(() => (ready && STRIPE_PK && !IS_MOCK ? connectInstance() : null), [ready]);

  return (
    <>
      <PageHeader title="Payments" subtitle="Money your website takes in. Refunds, disputes and payouts, all here." />
      {!ready ? <AcceptStripe /> : (
        <div className="flex w-full min-w-0 flex-col gap-6">
          {summary.data?.incomeMonth != null && (
            <p className="rounded-lg border border-hair bg-surface p-4 text-sm text-muted">
              Sold this month: <span className="font-head text-ink">{money(summary.data.incomeMonth)}</span>
            </p>
          )}
          {instance ? (
            <ConnectComponentsProvider connectInstance={instance}>
              <ConnectNotificationBanner />
              <section className="min-w-0"><h2 className="mb-3 font-head text-sm text-muted">Payouts</h2><ConnectPayouts /></section>
              <section className="min-w-0"><h2 className="mb-3 font-head text-sm text-muted">Payments and disputes</h2><ConnectPayments /></section>
            </ConnectComponentsProvider>
          ) : (
            <p className="rounded-lg border border-hair bg-surface p-5 text-sm text-muted">
              {IS_MOCK ? 'Payments preview (mock mode): Stripe’s payouts and payments lists show here.' : 'Payments are set up. Loading your account…'}
            </p>
          )}
        </div>
      )}
    </>
  );
}
